export default "__VITE_ASSET__7672c209__"